<template>
	<div class="x-header-nav">
		<div class="x-header-nav-fixed-box" :style="{ zIndex: props.zIndex }">
			<div class="x-header-nav-inner">
				<div class="x-header-nav-left">
					<span v-if="!hideBack" class="back-icon" @click="onBack">
						<van-icon name="arrow-left" />
					</span>
					<slot name="left" />
					<span v-if="!props.hideTitle && titlePosition === 'left'" class="x-header-nav-title">
						{{ props.title || title }}
					</span>
				</div>
				<div class="x-header-nav-mid">
					<slot name="mid" />
					<span v-if="!props.hideTitle && !titlePosition" class="x-header-nav-title">
						{{ props.title || title }}
					</span>
				</div>
				<div class="x-header-nav-right">
					<slot name="right" />
					<span v-if="!props.hideTitle && titlePosition === 'right'" class="x-header-nav-title">
						{{ props.title || title }}
					</span>
					<span v-if="!hideSearch" class="back-icon" @click="onSearch">
						<van-icon name="search" />
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
const props = defineProps<{
	theme?: string
	titlePosition?: string
	title?: string
	hideTitle?: boolean
	hideBack?: boolean
	hideSearch?: boolean
	zIndex?: number | string
}>()
const emit = defineEmits(['onSearch'])
const route = useRoute()
const router = useRouter()
const title = computed(() => route.meta.title)
onActivated(() => {
	if (props.theme === 'white') {
		document.documentElement.style.setProperty(`--x-header-navBg`, '#ffffff')
		document.documentElement.style.setProperty(`--x-header-color`, 'rgba(9, 13, 16, 1)')
	} else {
		document.documentElement.style.setProperty(`--x-header-navBg`, '#BD3A36')
		document.documentElement.style.setProperty(`--x-header-color`, '#fff')
	}
})

onMounted(() => {
	if (props.theme === 'white') {
		document.documentElement.style.setProperty(`--x-header-navBg`, '#ffffff')
		document.documentElement.style.setProperty(`--x-header-color`, 'rgba(9, 13, 16, 1)')
	} else {
		document.documentElement.style.setProperty(`--x-header-navBg`, '#BD3A36')
		document.documentElement.style.setProperty(`--x-header-color`, '#fff')
	}
})

const onSearch = () => {
	emit('onSearch')
}

const onBack = () => {
	router.back()
}
</script>

<style scoped lang="scss">
.x-header-nav {
	width: 375px;
	height: 44px;
	flex-shrink: 0;
	.x-header-nav-fixed-box {
		z-index: 3;
		position: fixed;
		left: 0;
		width: 100%;
		//background: var(--x-header-navBg);
		background-color: $primaryColor;
		background-image: url('@/assets/img/navBottomXQ.png');
		background-size: 100% 44px;
		.x-header-nav-right,
		.x-header-nav-left {
			align-items: center;
			display: flex;
		}
		.x-header-nav-inner {
			height: 44px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 10px;
			box-sizing: border-box;
			.x-header-nav-title {
				font-weight: 600;
				font-size: $bigFontSize;
				color: var(--x-header-color);
				line-height: 24px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.back-icon {
				font-size: 22px;
				font-weight: 500;
				color: var(--x-header-color);
			}
		}
	}
}
</style>
